export const EU_COUNTRIES = [
  // EU Member States
  'AT', // Austria
  'BE', // Belgium
  'BG', // Bulgaria
  'HR', // Croatia
  'CY', // Cyprus
  'CZ', // Czech Republic
  'DK', // Denmark
  'EE', // Estonia
  'FI', // Finland
  'FR', // France
  'DE', // Germany
  'GR', // Greece
  'HU', // Hungary
  'IE', // Ireland
  'IT', // Italy
  'LV', // Latvia
  'LT', // Lithuania
  'LU', // Luxembourg
  'MT', // Malta
  'NL', // Netherlands
  'PL', // Poland
  'PT', // Portugal
  'RO', // Romania
  'SK', // Slovakia
  'SI', // Slovenia
  'ES', // Spain
  'SE', // Sweden

  // Additional EEA countries subject to GDPR
  'IS', // Iceland
  'LI', // Liechtenstein
  'NO', // Norway

  // Countries with equivalent GDPR regulations
  'GB', // United Kingdom (UK GDPR)
  'CH', // Switzerland (similar data protection laws)
]

export function useGdpr() {
  const countryCookie = useCookie('country')

  // Use localStorage preference to stay in sync with PostHog plugin
  const cookiePreference = ref<string | null>(null)

  // Initialize from localStorage on client side
  onMounted(() => {
    if (typeof window !== 'undefined') {
      cookiePreference.value = localStorage.getItem('cookie-preference')

      // Auto-accept for non-EU users (sync with PostHog plugin behavior)
      if (!isEuCountry.value && !cookiePreference.value) {
        cookiePreference.value = 'accepted'
        localStorage.setItem('cookie-preference', 'accepted')
      }
    }
  })

  const isEuCountry = computed(() => {
    // Default to true if we can't determine the country
    if (!countryCookie.value) return true
    return EU_COUNTRIES.includes(countryCookie.value.toUpperCase())
  })

  const isConsentNeeded = computed(() => {
    // Consent is needed if user is in the EU
    return isEuCountry.value
  })

  const hasConsentBeenGiven = computed(() => {
    return cookiePreference.value === 'accepted'
  })

  const setConsentPreference = (preference: 'accepted' | 'declined') => {
    cookiePreference.value = preference
    // Only set localStorage to keep in sync with PostHog plugin
    if (typeof window !== 'undefined') {
      localStorage.setItem('cookie-preference', preference)
    }
  }

  const shouldShowCookieBanner = computed(() => {
    // Only show the banner for EU users who haven't set a preference
    return isConsentNeeded.value && !cookiePreference.value
  })

  // Helper to set country (for geolocation detection)
  const setCountry = (countryCode: string) => {
    countryCookie.value = countryCode.toUpperCase()
  }

  return {
    isEuCountry,
    isConsentNeeded,
    hasConsentBeenGiven,
    setConsentPreference,
    shouldShowCookieBanner,
    setCountry,
  }
}
